const translation = {
  Product: "Produkto",
  "Header.productNav": "Produkto ng LUKKEY",
  Feature: "Tampok",
  "About Us": "Tungkol sa Amin",
  FAQ: "Mga Madalas Itanong",
  "Privacy Policy": "Patakaran sa Privacy",
  "Help Center": "Sentro ng Tulong",
  "Header.infoMenu": "Higit pa",
  "Header.appNow": "Kunin ang app",
  "Header.appModal.title": "Gamitin ang LUKKEY app ngayon",
  "Header.appModal.subtitle": "Piliin ang iyong platform para makuha ang opisyal na LUKKEY mobile app.",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "I-install ang opisyal na app sa iPhone.",
  "Header.appModal.iosButton": "Buksan",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Kunin ang opisyal na Android app sa Google Play.",
  "Header.appModal.googlePlayButton": "Buksan",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "Direktang i-download ang pinakabagong opisyal na APK.",
  "Header.appModal.androidButton": "I-download",
  "Header.appModal.note": "Mga opisyal na mobile download lamang. Gamitin ang mga link sa itaas para sa pinakabagong bersyon.",
  "Academy": "Akademya",
  "Legal": "Legal",
  "AboutUs.title": "Tungkol sa LUKKEY",
  "AboutUs.lede": "Ang LUKKEY ay isang Swiss hardware wallet brand na nakatuon sa pinakamataas na pamantayan ng seguridad para sa pagmamay-ari ng digital assets.",
  "AboutUs.vision.closing": "Ang iyong mga susi. Ang iyong mga asset. Ang iyong kinabukasan.",
  "AboutUs.quote": "Binubuo ng LUKKEY ang security layer sa pagitan ng mga tao at digital assets.",
  "AboutUs.block1": "Nakabase ang LUKKEY sa Switzerland. Nakatuon ito sa mga hardware wallet na idinisenyo para sa ligtas na self-custody.",
  "AboutUs.block2": "Pinagsasama ng mga produkto nito ang secure elements, anti-tamper protection, at ganap na offline na arkitektura. Ang layunin ay panatilihin ang private keys sa isang hiwalay na kapaligiran.",
  "AboutUs.block3": "Dinisenyo ang system nang walang Wi‑Fi, USB, o direktang pag-asa sa network. Ang fingerprint access, NFC backup tools, at malawak na asset support ang nagpapanatiling praktikal nito sa araw-araw na paggamit.",
  "AboutUs.block5": "Sumusunod ang LUKKEY sa bukas at naa-audit na diskarte para sa core firmware at software. Dapat manatiling nasusuri at napapatunayan ang mga security claim.",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "Support request",
  "WarrantySupport.intro": "Pakipunan ang impormasyon sa ibaba upang magsumite ng support request.",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "Buod ng isyu",
  "WarrantySupport.form.issueTitle.placeholder": "Ilagay ang maikling buod",
  "WarrantySupport.form.warrantyType.label": "Uri ng request",
  "WarrantySupport.form.warrantyType.placeholder": "Pumili ng uri ng request",
  "WarrantySupport.form.warrantyType.product": "Isyu sa device",
  "WarrantySupport.form.warrantyType.service": "Isyu sa app/account",
  "WarrantySupport.form.warrantyType.replacement": "Iba pa",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "Ilarawan ang isyu o request nang detalyado",
  "WarrantySupport.form.submit": "Isumite ang support request",
  "WarrantySupport.alert.success": "Naipadala na ang iyong support request!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "Sentro ng Tulong",
  "HelpCenter.intro":
    "Maligayang pagdating sa LUKKEY Help Center! Kung bago ka sa cryptocurrency o kailangan mo ng tulong sa iyong cold wallet, nasa tamang lugar ka. Ang aming cold wallet solution ay nagbibigay ng pinakaligtas na paraan para mag-imbak at mag-manage ng iyong digital assets. Sa ibaba, makikita mo ang mga sagot sa mga karaniwang tanong at mga tip sa pag-troubleshoot.",
  "HelpCenter.section4.title": "Kailangan pa ng tulong?",
  "HelpCenter.section4.intro":
    "Makatipid ng oras sa pagsisimula ng iyong support request online at ikokonekta ka namin sa isang eksperto. Para sa iyong seguridad, ang opisyal na suporta ay hindi kailanman hihingi ng iyong recovery phrase o private key:",
  "HelpCenter.contact.hint": "Gamitin ang button para magpadala ng support request at makikipag-ugnayan kami sa email.",
  "HelpCenter.cta.warranty": "Magpadala ng support request",
  brandName: "LUKKEY",
  tagline: "Pamahalaan ang Iyong Crypto ng Higit Pa Kaysa Kailanman",
  description:
    "Simulan ang iyong paglalakbay patungo sa kalayaan sa pinansyal gamit ang aming app. Siguraduhin ang iyong mga ari-arian gamit ang aming advanced na teknolohiya ng cold wallet, at pamahalaan ang iyong mga pananalapi nang mas matalino at epektibo. Ang iyong pinansyal na kagalingan ang aming pangunahing layunin.",
  "home.seoTitle": "LUKKEY | Swiss hardware wallet para sa ligtas na self-custody",
  "home.seoDescription": "Ang LUKKEY ay isang Swiss hardware wallet brand na nakatuon sa cold wallet security, offline na proteksyon ng private key, fingerprint access, at NFC backup para sa mas ligtas na self-custody.",
  learnMore: "Alamin Pa",
  "Lock Your Crypto, Securely": "I-lock ang iyong Crypto nang Secure",
  Testimonials: "Mga Patotoo",
  Testimonial1:
    "Ginagamit ko na ang cold wallet na ito sa loob ng ilang buwan at humanga ako sa pagiging maaasahan at mga tampok ng seguridad nito. Lubos na inirerekomenda!",
  Testimonial2:
    "Ang cold wallet na ito ay lumampas sa aking mga inaasahan! Ang madaling gamitin na interface at nangungunang seguridad ay ginagawang isang kinakailangang kasangkapan para sa sinumang seryoso sa crypto.",
  Testimonial3:
    "Sinubukan ko na ang ilang cold wallets dati, ngunit ito ay namumukod. Ang sleek na disenyo at mga advanced na tampok nito ay ginagawang madali ang pamamahala ng aking mga crypto asset.",
  "John Doe": "John Doe",
  "Cryptocurrency Enthusiast": "Tagahanga ng Cryptocurrencies",
  "Jane Smith": "Jane Smith",
  "Crypto Security Advocate": "Tagapagtanggol ng Seguridad ng Crypto",
  "Alex Johnson": "Alex Johnson",
  "Investment Analyst": "Analista ng Pamumuhunan",
  "Touchscreen Interface": "Interface ng Touchscreen",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "Danasan ang walang kahirap-hirap na pamamahala ng crypto gamit ang aming intuitive na touchscreen interface, na dinisenyo para sa mabilis at madaling pag-navigate sa iyong mga digital na asset, na nagbibigay-daan sa mabilis na transaksyon at secure na pamamahala sa iyong mga daliri.",
  "Bluetooth Connectivity": "Koneksyon ng Bluetooth",
  "Wireless syncing with your devices for real-time updates.":
    "Walang wire na pagsi-sync sa iyong mga device para sa real-time na mga update.",
  "Airtag Tracking": "Pagsubaybay ng Airtag",
  "Track your wallet easily with built-in Airtag.":
    "Madaling subaybayan ang iyong wallet gamit ang naka-built in na Airtag.",
  "Secure Chip Technology": "Secure Chip Technology",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "Nilagyan ng advanced security chip, na tinitiyak ang malakas na proteksyon para sa iyong mga mahalagang digital na asset laban sa hindi awtorisadong pag-access at mga banta sa cyber.",
  "Cross-Platform Support": "Suporta sa Maraming Platform",
  "Works with various platforms for easy accessibility.":
    "Gumagana sa iba't ibang platform para sa madaling accessibility.",
  AboutUsDescription1:
    "Sa LUKKEY, nakatutok kami sa pagbibigay ng mga de-kalidad na solusyon para sa ligtas na pamamahala ng iyong mga cryptocurrency assets.",
  AboutUsDescription2:
    "Ang aming punong-tanggapan ay nasa Zug, Switzerland. Kasama ang isang koponan ng mga eksperyensadong propesyonal, nagsusumikap kaming mag-innovate at mag-adapt sa patuloy na nagbabagong tanawin ng merkado ng digital na pera.",
  BlockchainNetworksSupported: "Mga Suportadong Blockchain Networks",
  CryptocurrenciesSupported: "Sumusuporta sa Higit sa 6,000 Cryptocurrencies",
  Years: "Taon",
  ExpertiseInSecurity: "ng Ekspertisya sa Seguridad",
  FrequentlyAskedQuestions: "Mga Madalas Itanong",
  WhatIsColdWallet: "Ano ang Cold Wallet?",
  ColdWalletDescription:
    "Ang Cold Wallet ay isang uri ng cryptocurrency wallet na nag-iimbak ng iyong digital assets offline, kaya't mas ligtas ito mula sa mga hack at iba pang mga online na banta. Kumpara sa hot wallets, na konektado sa internet at maginhawa para sa mga madalas na transaksyon, ang cold wallets ay mas angkop para sa pangmatagalang pag-iimbak dahil nag-aalok ito ng pinahusay na seguridad.",
  HowToSetUpColdWallet: "Paano I-Set Up ang Iyong Cold Wallet?",
  ColdWalletSetupDescription:
    "Ang pag-setup ng iyong cold wallet ay karaniwang nagsasangkot ng pag-initialize ng device sa isang secure, offline na makina. Kailangan mong gumawa at ligtas na itago ang recovery phrase, na mahalaga para ma-access ang iyong mga assets sa oras ng pagkawala ng device o pagkasira nito. Ang mga detalyadong tagubilin ay ibinibigay sa iyong pagbili upang matiyak ang isang maayos na proseso ng pag-setup.",
  CryptocurrenciesCompatibleWithColdWallet:
    "Aling mga cryptocurrencies ang katugma ng iyong cold wallet?",
  CryptocurrenciesCompatibilityDescription:
    "Ang aming mga cold wallet ay sumusuporta sa isang malawak na hanay ng mga cryptocurrencies, kabilang ang mga pangunahing tulad ng Bitcoin, Ethereum, at Litecoin, pati na rin ang iba't ibang altcoin. Para sa isang kumpletong listahan ng mga suportadong pera, mangyaring bisitahin ang aming website o tingnan ang dokumentasyon ng produkto.",
  HowToSecureColdWallet:
    "Paano ko matitiyak na ang aking cold wallet ay ligtas?",
  ColdWalletSecurityDescription:
    "Upang matiyak ang seguridad ng iyong cold wallet, palaging itago ang recovery phrase sa isang ligtas at pribadong lokasyon, huwag itong ibahagi kaninuman, at isaalang-alang ang paggamit ng karagdagang mga hakbang sa seguridad tulad ng biometric locks o secure enclosures. Ang regular na pag-update ng firmware ng wallet mula sa opisyal na website ay nakakatulong din upang maprotektahan laban sa mga kahinaan.",
  ColdWalletNotWorking:
    "Ano ang dapat kong gawin kung hindi gumagana ang aking cold wallet o kung nakatagpo ako ng isang error?",
  ColdWalletErrorDescription:
    "Kung nakakaranas ka ng mga problema sa iyong cold wallet, mangyaring sumangguni sa seksyon ng pag-troubleshoot sa aming gabay ng gumagamit. Para sa mas partikular na mga isyu, makipag-ugnayan sa aming support team sa pamamagitan ng aming website. Siguraduhing mayroon kang impormasyon ng iyong device upang mapabilis ang proseso ng suporta.",
  Community: "Komunidad",
  "Subscribe.title": "Kumuha ng mga update ng produkto",
  "Subscribe.subtitle":
    "Sinusubaybayan namin ang crypto trends para sa’yo. Tumanggap ng mga update sa produkto, kaalaman sa merkado, at eksklusibong benepisyo — diretso sa iyong inbox.",
  "Subscribe.placeholder": "Ilagay ang iyong email",
  "Subscribe.button": "Mag-subscribe sa mga update ng produkto",
  "Subscribe.input.aria": "Patlang ng pag-input ng email address",
  "Subscribe.success":
    "Salamat sa pag-subscribe! Pakisuri ang email ng kumpirmasyon.",
  "Subscribe.error": "Nabigo ang subscription. Pakisubukang muli mamaya.",
  "Subscribe.invalid": "Pakilagay ang wastong email address.",
  "Subscribe.privacy":
    "Gagamitin lamang ang iyong email address para sa pagpapadala ng aming newsletter at mga update. Maaari kang mag-unsubscribe anumang oras sa pamamagitan ng link sa email.",
  "Subscribe.learnMore":
    "Alamin pa kung paano namin pinamamahalaan ang iyong datos at mga karapatan.",
  "Subscribe.popupCompact.title": "Manatiling updated",
  "Subscribe.popupCompact.subtitle":
    "Mga update sa produkto at security insights. Walang spam.",
  "Subscribe.popupCompact.button": "Mag-subscribe",
  "Subscribe.popupCompact.privacy":
    "Email lang. Maaari kang mag-unsubscribe anumang oras.",
  "SubscribeConfirmed.alt.success": "Nakumpirma ang subscription",
  "SubscribeConfirmed.alt.failed": "Nabigo ang subscription",
  "SubscribeConfirmed.title.success": "Nakumpirma ang subscription",
  "SubscribeConfirmed.title.failed": "Nabigo ang subscription",
  "SubscribeConfirmed.message.success":
    "Salamat sa pagkumpirma ng iyong email. Aktibo na ang iyong subscription. Naipadala na ang welcome email sa iyong inbox.",
  "SubscribeConfirmed.message.failed":
    "Hindi wasto o paso na ang link ng kumpirmasyon. Pakibang bumalik sa homepage at subukang mag-subscribe muli.",
  "SubscribeConfirmed.cta.backHome": "Bumalik sa Homepage",
  "SubscribeConfirmed.note.unsubscribe":
    "Maaari kang mag-unsubscribe anumang oras sa pamamagitan ng link sa aming mga email.",
  // ===== MarketView i18n =====
  "MarketView.title": "Dashboard ng Merkado",
  "MarketView.loading": "Naglo-load...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "Nabigong i-render ang tab na ito",
  "MarketView.unknownError": "Hindi kilalang error",

  // ===== Common i18n =====
  "Common.refresh": "I-refresh",
  "Common.toggleSeriesVisibility": "I-toggle ang seryeng ito",
  "Common.error": "Error",
  "Common.dataUpdateTime": "Oras ng pag-update ng datos",
  "Common.loading": "Naglo-load...",
  "Common.noDataSource":
    "Walang datos (hindi ibinigay ang pinagmulan ng datos)",

  // ===== Common ranges =====
  "Common.to": "hanggang",
  "Common.clear": "I-clear",
  "Common.range.thisMonth": "Buwan na ito",
  "Common.range.lastMonth": "Nakaraang buwan",
  "Common.range.last2": "Huling 2 buwan",
  "Common.range.last3": "Huling 3 buwan",
  "Common.range.last6": "Huling 6 na buwan",
  "Common.range.thisYear": "Taong ito",
  "Common.range.all": "Lahat",
  "Common.range.custom": "Custom",
  "Common.showFilters": "Ipakita ang mga filter",
  "Common.hideFilters": "Itago ang mga filter",
  "Common.search": "Maghanap",
  "Common.priority": "Prayoridad",
  "Common.owner": "May-ari",
  "Common.collaborator": "Kasamang tagapag-ambag",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "I-download ang backend data/youtube_stats.json",
  "YouTubeTab.downloadJson": "I-download ang youtube_stats.json",
  "YouTubeTab.loading": "Naglo-load ng mga sukatan ng YouTube...",
  "YouTubeTab.errorHint":
    "Kung walang na-configure na API key, itakda ang YOUTUBE_API_KEY o GOOGLE_API_KEY sa backend/.env at i-restart ang backend.",
  "YouTubeTab.header.totalViews": "Kabuuang Views (Multi-channel, Yunit: 10k)",
  "YouTubeTab.header.totalSubscribers":
    "Kabuuang Subscribers (Multi-channel, Yunit: 10k)",
  "YouTubeTab.dist.views": "Distribusyon ng Views (10k)",
  "YouTubeTab.dist.subscribers": "Distribusyon ng Subscribers (10k)",
  "YouTubeTab.card.location": "Lokasyon:",
  "YouTubeTab.card.registeredAt": "Nirehistro noong:",
  "YouTubeTab.card.currentSubscribers": "Kasalukuyang Subscribers",
  "YouTubeTab.card.currentVideos": "Kasalukuyang Dami ng Video",
  "YouTubeTab.card.currentTotalViews": "Kasalukuyang Kabuuang Views",
  "YouTubeTab.card.currentTotalComments": "Kasalukuyang Kabuuang Komento",
  "YouTubeTab.chart.totalSubscribers": "Kabuuang Subscribers",
  "YouTubeTab.chart.totalViews": "Kabuuang Views",
  "YouTubeTab.chart.totalComments": "Kabuuang Komento",
  "YouTubeTab.chart.totalVideos": "Kabuuang Video",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "I-download ang backend data/x_stats.json",
  "XTab.downloadJson": "I-download ang x_stats.json",
  "XTab.loading": "Naglo-load ng mga sukatan ng X...",
  "XTab.errorHint":
    "Kung walang na-configure na token, itakda ang X_BEARER_TOKEN o TWITTER_BEARER_TOKEN sa backend/.env at i-restart ang backend.",
  "XTab.header.totalFollowers":
    "Kabuuang Followers (Multi-channel, Yunit: 10k)",
  "XTab.header.totalEngagement":
    "Kabuuang Engagement (huling 5 post: Likes + Retweets + Replies + Quotes, Yunit: 10k)",
  "XTab.dist.followers": "Distribusyon ng Followers (10k)",
  "XTab.dist.engagement":
    "Distribusyon ng Engagement (huling 5 post: Likes + Retweets + Replies + Quotes, 10k)",
  "XTab.card.currentFollowers": "Kasalukuyang Followers",
  "XTab.card.currentFollowing": "Kasalukuyang Following",
  "XTab.card.currentTweets": "Kasalukuyang Dami ng Tweet",
  "XTab.card.recentLikes": "Mga Like kamakailan (huling 5 post)",
  "XTab.card.recentRetweets": "Mga Retweet kamakailan (huling 5 post)",
  "XTab.card.recentReplies": "Mga Reply kamakailan (huling 5 post)",
  "XTab.card.recentQuotes": "Mga View kamakailan (antas-konten, huling 5 post)",
  "XTab.card.listed": "Dami ng pagkakalista (antas-channel)",
  "XTab.smallChart.followers": "Followers",
  "XTab.smallChart.tweets": "Tweets",
  "XTab.smallChart.likes": "Mga Like kamakailan",
  "XTab.smallChart.retweets": "Mga Retweet kamakailan",
  "XTab.smallChart.replies": "Mga Reply kamakailan",
  "XTab.smallChart.quotes": "Mga View kamakailan (antas-konten)",
  "XTab.smallChart.following": "Following",
  "XTab.smallChart.listed": "Nakalista",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "I-filter ayon sa buwang nilikha:",
  "Analytics.dashboardTitle": "Dashboard ng Kalusugan ng Proyekto",
  "Analytics.metric.completionRate": "Antas ng Pagkumpleto",
  "Analytics.metric.teamVelocity": "Bilis ng Team",
  "Analytics.metric.blockerRatio": "Proporsyon ng Blocker",
  "Analytics.metric.workloadBalance": "Balanse ng Trabaho",
  "Analytics.charts.statusDistribution": "Distribusyon ng Katayuan",
  "Analytics.charts.statusByMonthPercent": "Katayuan ayon sa Buwan (Porsyento)",
  "Analytics.charts.priorityDistribution": "Distribusyon ng Prayoridad",
  "Analytics.charts.priorityByMonthPercent":
    "Prayoridad ayon sa Buwan (Porsyento)",
  "Analytics.charts.functionTypeDistribution":
    "Distribusyon ayon sa Uri ng Gawain",
  "Analytics.charts.functionTypeByMonthPercent":
    "Uri ng Gawain ayon sa Buwan (Porsyento)",
  "Analytics.blocker.ownerPie":
    "Mga Naka-block na Isyu · Distribusyon ng May-ari (donut)",
  "Analytics.blocker.ownerByMonth":
    "Mga Naka-block na Isyu · May-ari ayon sa Buwan (Porsyento)",
  "Analytics.bug.ownerPie": "Mga Bug na Isyu · Distribusyon ng May-ari (donut)",
  "Analytics.bug.ownerByMonth":
    "Mga Bug na Isyu · May-ari ayon sa Buwan (Porsyento)",
  "Analytics.ownerWorkloadDistribution": "Distribusyon ng Workload ng Team",
  "Analytics.mode.priority": "Distribusyon ng Prayoridad",
  "Analytics.mode.status": "Distribusyon ng Katayuan",
  "Analytics.mode.type": "Distribusyon ng Uri",
  "Analytics.blocker.attentionNeeded":
    "Mga isyung nangangailangan ng agarang atensyon",
  "Analytics.common.status": "Katayuan",
  "Analytics.common.owner": "May-ari",
  "Analytics.insights.sectionTitle": "Mga Insight at Rekomendasyon",
  "Analytics.insights.efficiency.title": "Mga mungkahi sa pagpapahusay ng bisa",
  "Analytics.insights.efficiency.completionRate":
    "• Ang kasalukuyang completion rate ay {{rate}}%, bantayan ang mga blocker",
  "Analytics.insights.efficiency.avgVelocity":
    "• Ang average na bilis ng team ay {{velocity}} gawain/tao",
  "Analytics.insights.efficiency.workloadBalance":
    "• Ang workload balance ay {{balance}}%",
  "Analytics.insights.risk.title": "Mga Babala sa Panganib",
  "Analytics.insights.risk.blockerRatio": "• Proporsyon ng blocker {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• Proporsyon ng P0 na isyu {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• Unahin munang lutasin ang mga high-priority na isyu",

  // ===== Kanban i18n =====
  "Kanban.title": "Kanban View",
  "Kanban.totalIssues": "Kabuuang {{count}} isyu",
  "Kanban.searchPlaceholder":
    "Maghanap ng pamagat, numero ng isyu, may-ari o mga kasamang tagapag-ambag...",
  "Kanban.status.backlog": "Backlog",
  "Kanban.status.inProgress": "Ginagawa",
  "Kanban.status.blocked": "Naka-block / Naghihintay ng kumpirmasyon",
  "Kanban.status.reviewTest": "Rebyu / Pagsusuri",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "Listahan ng Isyu",
  "List.totalIssues": "Kabuuang {{count}} isyu",
  "List.viewDetails": "Tingnan ang detalye",
  "List.openInNewWindow": "Buksan sa bagong window",
  "List.empty.title": "Walang isyu",
  "List.empty.subtitle":
    "Gumawa ng unang isyu upang simulan ang daloy ng trabaho",

  // ===== Assets Register i18n =====
  "Assets.title": "Rehistro ng Asset",
  "Assets.totalSets": "Kabuuang Sets",
  "Assets.table.employee": "Empleyado",
  "Assets.table.setCount": "Sets",
  "Assets.table.model": "Modelo",
  "Assets.total": "Kabuuan",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "Pagsubaybay ng Isyu ng Proyekto",
  "LukkeyIssues.goToDemo": "Pumunta sa Demo Page",
  "LukkeyIssues.githubProject": "GitHub Project ↗",
  "LukkeyIssues.githubManageIssues":
    "Pamahalaan ang Issues direkta sa GitHub ↗",
  "LukkeyIssues.financeModel": "Modelo sa Pinansya",
  "LukkeyIssues.productCoreIssues": "Mga Core na Isyu ng Produkto",
  "LukkeyIssues.stats.totalIssues": "📊 Kabuuang Isyu",
  "LukkeyIssues.stats.completed": "✅ Kumpleto",
  "LukkeyIssues.stats.inProgress": "🔄 Ginagawa",
  "LukkeyIssues.stats.pending": "⏳ Naghihintay",
  "LukkeyIssues.stats.blocked": "🚫 Naka-block",
  "LukkeyIssues.stats.docs": "📚 Docs",
  "LukkeyIssues.tabs.kanban": "Kanban View",
  "LukkeyIssues.tabs.analytics": "Analytics",
  "LukkeyIssues.tabs.market": "Dashboard ng Merkado",
  "LukkeyIssues.tabs.assets": "Rehistro ng Asset",
  "LukkeyIssues.shareToChatGPT": "Buksan ang LUKKEY.json sa ChatGPT", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "Patakaran sa Privacy ng LUKKEY",
  "PrivacyPolicy.intro.p1":
    "Sa LUKKEY, naniniwala kami na ang pinakaligtas na anyo ng privacy ay yaong palaging nananatili sa mga kamay ng mismong gumagamit.",
  "PrivacyPolicy.intro.p2":
    "Kaya, maging ginagamit mo ang LUKKEY hardware cold wallet o ang LUKKEY mobile application (App), mahigpit kaming sumusunod sa isang di-matitinag na prinsipyo:",
  "PrivacyPolicy.intro.p3_strong":
    "Maliban kung hayagang pinahihintulutan ng gumagamit, hindi kami nangongolekta, nag-iimbak, o nag-a-upload ng anumang impormasyon ng gumagamit.",
  "PrivacyPolicy.intro.p3_tail":
    "Ang lahat ng datos na may kinalaman sa paggamit ay nakaimbak lamang sa lokal na device ng gumagamit at hindi kailanman ipinapadala sa LUKKEY o sa anumang server.",
  "PrivacyPolicy.intro.p4":
    "Ipinaliliwanag ng Patakaran sa Privacy na ito kung paano namin isinasakatuparan ang prinsipyong ito.",

  "PrivacyPolicy.s1.title": "1. Saklaw ng Paglalapat",
  "PrivacyPolicy.s1.appliesTo": "Saklaw ng Patakaran sa Privacy na ito ang:",
  "PrivacyPolicy.s1.item.hardware": "LUKKEY hardware cold wallet",
  "PrivacyPolicy.s1.item.app": "LUKKEY mobile application (App)",
  "PrivacyPolicy.s1.principle":
    "Parehong sumusunod sa pinag-isang prinsipyo ng privacy na “zero collection, zero upload, local-only storage”.",

  "PrivacyPolicy.s2.title": "2. Impormasyong HINDI namin kinokolekta",
  "PrivacyPolicy.s2.desc":
    "Upang maprotektahan ang iyong privacy, hayagan kaming nangakong hindi mangongolekta, mag-a-upload, o mag-iimbak ng anumang impormasyon ng gumagamit, kabilang ngunit hindi limitado sa:",
  "PrivacyPolicy.s2.li.identity":
    "Impormasyon sa pagkakakilanlan: pangalan, numero ng telepono, email address, tirahan",
  "PrivacyPolicy.s2.li.walletSensitive":
    "Sensitibong datos ng wallet: mga private key, mnemonic phrases, mga keystore file, mga password ng wallet",
  "PrivacyPolicy.s2.li.blockchain":
    "Datos ng blockchain: mga address ng wallet, kasaysayan ng transaksyon, impormasyon ng asset",
  "PrivacyPolicy.s2.li.behavior":
    "Ugali ng paggamit: mga log ng app, mga rekord ng pag-click, behavior analytics",
  "PrivacyPolicy.s2.li.technical":
    "Impormasyong teknikal: mga identifier ng device, lokasyon (geolocation), IP address",
  "PrivacyPolicy.s2.inShort.title": "Sa madaling sabi:",
  "PrivacyPolicy.s2.inShort.desc":
    "Lahat ng nakikita mo sa hardware device at sa App ay umiiral lamang sa iyong device. Hindi ito naa-access ng LUKKEY.",

  "PrivacyPolicy.s3.title":
    "3. Disenyo ng Privacy at Seguridad ng Hardware Cold Wallet",
  "PrivacyPolicy.s3.desc":
    "Nagbibigay ang LUKKEY cold wallet ng ganap na offline at ligtas na kapaligiran. Pangunahing katangian:",
  "PrivacyPolicy.s3.h1.title": "1. Seguridad na antas-militar sa hardware",
  "PrivacyPolicy.s3.h1.l1": "Secure Element na sertipikadong EAL6+",
  "PrivacyPolicy.s3.h1.l2":
    "Buong komunikasyong naka-encrypt sa antas ng hardware",
  "PrivacyPolicy.s3.h2.title": "2. Mga tungkulin sa seguridad",
  "PrivacyPolicy.s3.h2.l1": "Fingerprint authentication",
  "PrivacyPolicy.s3.h2.l2": "Privacy mode",
  "PrivacyPolicy.s3.h2.l3": "Hiwalay na pamamahala ng multi-wallet",
  "PrivacyPolicy.s3.h3.title": "3. Ganap na isolation",
  "PrivacyPolicy.s3.h3.l1": "Walang koneksyon sa Internet",
  "PrivacyPolicy.s3.h3.l2": "Walang koneksyon sa data cable",
  "PrivacyPolicy.s3.h4.title": "4. Anti-tamper na may self-destruct",
  "PrivacyPolicy.s3.h4.desc":
    "Kung ang device ay binaklas, nasira, o nakaranas ng abnormal na panghihimasok, awtomatikong winawasak ng Secure Element ang sensitibong datos upang hindi ma-extract ang mga private key.",
  "PrivacyPolicy.s3.h5.title":
    "5. Mga sensitibong operasyon ay isinasagawa lamang sa loob ng Secure Element",
  "PrivacyPolicy.s3.h5.l1": "Paglikha ng wallet",
  "PrivacyPolicy.s3.h5.l2": "Pag-import ng wallet",
  "PrivacyPolicy.s3.h5.l3": "Pagpirma ng transaksyon",
  "PrivacyPolicy.s3.h5.note":
    "Ang lahat ng sensitibong proseso ay 100% nagaganap sa loob ng Secure Element at hindi kailanman inilalantad sa anumang hindi ligtas na chip o imbakan.",
  "PrivacyPolicy.s3.h6.title":
    "6. Walang sensitibong datos sa labas ng Secure Element",
  "PrivacyPolicy.s3.h6.desc":
    "Ang mga hindi ligtas na lugar ng imbakan sa device ay hindi kailanman naglalaman ng mga private key, mnemonic, o anumang sensitibong impormasyon.",

  "PrivacyPolicy.s4.title": "4. Disenyo ng Privacy at Seguridad ng LUKKEY App",
  "PrivacyPolicy.s4.desc":
    "Ang LUKKEY App ay nakatuon lamang sa pagpapakita ng impormasyon at pagbibigay ng mga abiso. Hindi ito humahawak ng sensitibong datos ng wallet.",
  "PrivacyPolicy.s4.n1.title": "1. Mga HINDI ginagawa ng App",
  "PrivacyPolicy.s4.n1.l1": "Hindi bumubuo ng mga blockchain wallet",
  "PrivacyPolicy.s4.n1.l2": "Hindi nag-i-import ng mga blockchain wallet",
  "PrivacyPolicy.s4.n1.l3":
    "Hindi nag-iimbak ng mga private key o mnemonic phrases",
  "PrivacyPolicy.s4.n1.l4": "Hindi nag-a-upload ng anumang datos ng gumagamit",
  "PrivacyPolicy.s4.n1.l5":
    "Hindi nagsasagawa ng behavior analytics, ad tracking, o pangongolekta ng datos",
  "PrivacyPolicy.s4.n2.title": "2. Mga GINAGAWA ng App",
  "PrivacyPolicy.s4.n2.l1":
    "Nagpapakita ng publikong impormasyong pinahintulutan ng hardware",
  "PrivacyPolicy.s4.n2.l2":
    "Nagbibigay ng privacy settings panel na nagpapaliwanag ng layunin ng bawat permiso",
  "PrivacyPolicy.s4.n2.l3":
    "Nagbibigay sa mga gumagamit ng buong kontrol upang i-enable/disable ang mga permiso anumang oras",
  "PrivacyPolicy.s4.n2.l4":
    "Nag-aalok ng masking para sa sensitibong impormasyon",
  "PrivacyPolicy.s4.n2.l5":
    "Nagdi-disable ng screenshot/recording sa ilang mga view",
  "PrivacyPolicy.s4.n2.l6":
    "Nakatutuklas ng kahina-hinalang blockchain addresses sa pamamagitan ng lokal na pagtutugma",
  "PrivacyPolicy.s4.n2.l7":
    "Regular na ina-update ang mga mapanganib na URL, kontrata, at mga address",
  "PrivacyPolicy.s4.n2.l8":
    "Isang‑daan ang agos ng update: server → device lamang",
  "PrivacyPolicy.s4.n2.l9":
    "Walang datos ng gumagamit na ipinapadala pabalik habang nag-a-update",
  "PrivacyPolicy.s4.n3.title": "3. Lokal na imbakan",
  "PrivacyPolicy.s4.n3.p1":
    "Tanging di‑pribadong datos lamang ang iniimbak ng App sa lokal, gaya ng UI preferences, wika, at tema. Ang datos na ito ay:",
  "PrivacyPolicy.s4.n3.l1": "hindi ina-upload",
  "PrivacyPolicy.s4.n3.l2": "hindi sini-sync",
  "PrivacyPolicy.s4.n3.l3": "hindi naa-access ng LUKKEY",

  "PrivacyPolicy.s5.title": "5. Pagpapadala ng Datos at Patakaran sa Server",
  "PrivacyPolicy.s5.l1":
    "Hindi nag-iimbak ang mga server ng LUKKEY ng anumang impormasyon ng gumagamit",
  "PrivacyPolicy.s5.l2":
    "Limitado ang komunikasyon ng App–server sa mga update ng database at bersyon",
  "PrivacyPolicy.s5.l3":
    "Walang impormasyong pang‑gumagamit ang naipapadala sa panahon ng komunikasyon",
  "PrivacyPolicy.s5.l4":
    "Kahit pa ma-kompromiso ang server, walang datos ng gumagamit na malalantad sapagkat kailanman ay hindi kami kumukuha ng gayong datos",

  "PrivacyPolicy.s6.title": "6. Open‑Source na Transparency",
  "PrivacyPolicy.s6.l1": "Open‑source ang source code ng LUKKEY App",
  "PrivacyPolicy.s6.l2": "Open‑source ang embedded firmware ng LUKKEY hardware",
  "PrivacyPolicy.s6.l3":
    "Ganap na magagamit sa GitHub para sa sinumang nagnanais na magsuri",
  "PrivacyPolicy.s6.p": "Ang transparency ay bahagi ng seguridad.",

  "PrivacyPolicy.s7.title": "7. Buong Kontrol ng Gumagamit",
  "PrivacyPolicy.s7.p":
    "Kahit hindi kami nangongolekta ng impormasyon ng gumagamit, nananatili pa rin ang buong kontrol ng mga gumagamit sa kanilang mga device:",
  "PrivacyPolicy.s7.l1":
    "Maaari mong i-disable ang mga permiso ng App anumang oras",
  "PrivacyPolicy.s7.l2":
    "Maaari mong i-uninstall ang App upang burahin ang lahat ng lokal na datos ng App",
  "PrivacyPolicy.s7.l3":
    "Maaari mong i-reset ang hardware device upang permanenteng burahin ang mga private key at datos ng wallet",
  "PrivacyPolicy.s7.p2":
    "Hindi nakikialam at hindi maaaring makialam ang LUKKEY sa mga pagkilos na ito.",

  "PrivacyPolicy.s8.title": "8. Makipag-ugnayan sa Amin",
  "PrivacyPolicy.s8.p":
    "Kung mayroon kang anumang katanungan hinggil sa Patakaran sa Privacy na ito, mangyaring makipag-ugnayan sa amin:",
  "PrivacyPolicy.s8.email": "Email: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "Address: Punong-tanggapan ng LUKKEY, Baarerstrasse 25, 6300 Zug, Switzerland",

  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "Sinusuri...",
  "EmailOtp.title":
    "Limitadong access: ilagay ang pangalan at email para makatanggap ng code sa pag-login",
  "EmailOtp.nameLabel": "Pangalan",
  "EmailOtp.namePlaceholder": "Ilagay ang iyong pangalan",
  "EmailOtp.emailLabel": "Email",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "Ipadala ang code",
  "EmailOtp.resendCode": "Ipadala muli ang code",
  "EmailOtp.resendWithCountdown": "Ipadala muli sa loob ng {{s}} segundo",
  "EmailOtp.codeValidityHint":
    "Balido ang verification code sa loob ng 5 minuto. Huwag itong ibahagi kaninuman.",
  "EmailOtp.codeLabel": "Code ng beripikasyon sa email",
  "EmailOtp.codePlaceholder": "Ilagay ang natanggap na code",
  "EmailOtp.signIn": "Mag-sign in",
  "EmailOtp.message.codeSent":
    "Naipadala na ang verification code sa iyong email.",
  "EmailOtp.error.nameRequired": "Pakilagay ang pangalan",
  "EmailOtp.error.invalidEmail": "Pakilagay ang wastong email address",
  "EmailOtp.error.sendFailed":
    "Nabigo ang pagpapadala ng verification code. Subukan muli mamaya.",
  "EmailOtp.error.codeRequired": "Pakilagay ang verification code",
  "EmailOtp.error.verificationFailed": "Nabigo ang beripikasyon",
  // ===== Academy i18n =====
  "Academy.hero.alert": "Paalala sa Seguridad: Laging i‑verify ang mga link at huwag kailanman ibahagi ang recovery phrase.",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "Akademya",
  "Academy.hero.subtitle": "Praktikal na gabay sa crypto security, self‑custody, at paggamit ng LUKKEY cold wallet.",
  "Academy.search.placeholder": "Maghanap ng tutorials, best practices, at FAQs…",
  "Academy.search.hint": "[ENTER]",
  "Academy.card.type.article": "ARTIKULO",
  "Academy.list.title": "Pinakabagong Gabay",
  "Academy.list.viewAll": "TINGNAN LAHAT",
  "Academy.list.empty": "Walang resulta. Subukan ang ibang keyword.",
  "Academy.image.placeholder": "LARAWAN",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "Bumalik sa Akademya",
  "AcademyArticle.notFound": "Hindi natagpuan ang artikulo",
  "AcademyArticle.author": "May‑akda",
  "AcademyArticle.unscheduled": "Walang nakatakdang oras ng publikasyon",
  "home.hero.reserveCtaLabel": "Maagang access — $1",
  "home.hero.reserveCtaNote": "Ganap na refundable. Walang obligasyong bumili."
};
export default translation;
